export const getJourneyUsageProjectections = (
  limit: number,
  currentUsage: number,
  projectedUsers = 0,
) => {
  if (limit <= 0) {
    return {
      projectedUsagePercentage: 0,
      totalProjectedUsage: 0,
      willLimitBeReached: false,
    };
  }

  const projectedUsagePercentage = Math.round((projectedUsers / limit) * 100);
  const currentUsagePercentage = Math.round((currentUsage / limit) * 100);
  const totalProjectedUsage = currentUsagePercentage + projectedUsagePercentage;
  const willLimitBeReached = totalProjectedUsage >= 75;

  return {
    projectedUsagePercentage,
    totalProjectedUsage,
    willLimitBeReached,
  };
};
